<template>
  <div class="flex items-center gap-4 md:gap-1">
    <div class="flex size-12 items-center justify-center">
      <component :is="icon" class="size-7 fill-gray-300" />
    </div>
    <div>
      <h3 class="text-md font-medium leading-normal md:mb-1 lg:text-xl">
        {{ title }}
      </h3>
      <p class="text-md font-normal">{{ description }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title: string
  description: string
  icon: string
}>()
</script>
